module.exports = __webpack_public_path__ + "static/dmon-022-d3b702e264b204c9b588a9de8e511a00.jpg";